export default __webpack_public_path__ + "static/media/user-placeholder.1a44de17.svg";